import type { Auth0ProviderOptions } from '@auth0/auth0-react';

/**
 * Token-handling options for Auth0Provider, split out of App.tsx (same
 * pattern as sentryConfig.ts) so regression tests can pin the settings
 * that have caused production incidents.
 */
export const auth0TokenOptions: Pick<
    Auth0ProviderOptions,
    'cacheLocation' | 'useRefreshTokens' | 'useRefreshTokensFallback'
> = {
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    // Never fall back to hidden-iframe silent auth. On iOS WebKit, ITP blocks
    // the third-party Auth0 session cookie inside the iframe, so the fallback
    // can only fail with login_required — which the SDK answers with
    // logout({ openUrl: false }), flipping the auth state, retriggering
    // getTokenSilently, spawning the next iframe… until the page crashes with
    // "RangeError: Maximum call stack size exceeded" (CHAT-MARITACA-10).
    // Without the fallback, a missing refresh token fails fast with
    // MissingRefreshTokenError and the app degrades to the login screen.
    useRefreshTokensFallback: false,
};
